import { useEffect } from "react";
import styles from "./Input.module.css";

export default function Input({
  isTextArea = false,
  error = false,
  setError = (e) => {},
  label,
  setValue,
  value,
  props,
  type = "text",
}) {
  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>{label}</label>
      {isTextArea ? (
        <textarea
          className={`${styles.textarea} ${styles[error && `error-field`]}`}
          onChange={(e) => {
            setError(false);
            setValue(e.currentTarget.value);
          }}
          value={value}
          {...props}
        />
      ) : (
        <input
          className={`${styles.input} ${styles[error && `error-field`]}`}
          value={value}
          type={type}
          onChange={(e) => {
            setError(false);
            setValue(e.currentTarget.value);
          }}
          {...props}
        />
      )}
    </div>
  );
}
